import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
// import router from '../../src/router'

/* eslint-disable */
export default {
    state: {
        vitrineItems: [],
        currentItems: [],
        questions: [],
        firstPoint: {},
        points: [],
        markers: [],
        mapParameters: '',
        imageUrl: '',
        gameData: '',
        welcomePageData: "",
        loading: false,
        loadingVitrinesOnly: false,
        results: [],
        questionsList: '',
        lang: 'he',
        users: [],
        allVitrines: [],
        vitrinesMain: [],
        allVitrinesOnly: '',
        vitrineArrayOnly: [],
        vitrineOnlyArrayForAdmin: [],
        currentItemsArray: [],
        vitrine1: [],
        vitrine2: [],
        vitrine3: [],
        vitrine4: [],
        vitrine5: [],
        vitrine6: [],
        vitrine7: [],
        vitrine8: [],
        vitrine9: [],
        vitrine10: [],
        vitrine11: [],
        vitrine12: [],
        vitrine13: [],
        vitrine14: [],
        vitrine15: [],
        vitrine16: [],
        vitrine17: [],
        vitrine18: [],
        vitrine19: [],
        vitrine20: [],
        vitrine21: [],
        vitrine22: [],
        vitrine23: [],
        vitrine24: [],
        vitrine25: [],
        vitrine26: [],
        vitrine27: [],


        vitrineOrder: []
    },
    mutations: {
        switchLang(state, payload) {
            state.lang = payload
        },
        setQuestionList(state, payload) {
            // console.log("[setQuestionList] payload", payload)
            state.questionsList = payload
        },
        // addResult(state, payload) {
        //     state.results.push(payload)
        // },
        setMapParameters(state, payload) {
            state.mapParameters = payload
        },
        // setWelcomePage(state, payload) {
        //     // console.log('[mutations] setWelcomePage payload', payload)
        //     state.welcomePage = payload
        // },
        // setLettersArray(state, payload) {
        //     state.lettersArray = payload
        // },
        // setGameParameters(state, payload) {
        //     state.gameParameters = payload
        // },
        setAllNavGameNames(state, payload) {
            state.allNavGameNames = payload
        },
        setUser(state, payload) {
            // console.log("[setUser] payload", payload)
            state.user = payload
        },
        setLoading(state, payload) {
            state.loading = payload
            // console.log("[mutations] setLoading => state.loading", state.loading)
        },
        setLoadingVitrinesOnly(state, payload) {
            state.loadingVitrinesOnly = payload
            // console.log("[mutations] loadingVitrinesOnly => state.loadingVitrinesOnly", state.loadingVitrinesOnly)
        },
        setVitrineOrder(state, payload) {
            state.vitrineOrder = payload
            // console.log("[mutations] loadingVitrinesOnly => state.loadingVitrinesOnly", state.loadingVitrinesOnly)
        },
        setPointsArray(state, payload) {
            state.pointsArrayOrder = payload
        },
        setPoints(state, payload) {
            state.points = payload
        },
        setVitrineItems(state, payload) {
            state.vitrineItems = payload
        },
        setFirstPoint(state, payload) {
            state.firstPoint = payload
        },
        setVitrines(state, payload) {
            state.allVitrines = payload
        },
        setVitrinesMain(state, payload) {
            state.vitrinesMain = payload
        },
        setVitrineOnlyArray(state, payload) {
            state.vitrineArrayOnly = payload
        },
        setVitrineOnlyArrayForAdmin(state, payload) {
            // console.log("[setVitrineOnlyArrayForAdmin] payload", payload)
            state.vitrineOnlyArrayForAdmin = payload
        },

        setCurrentItems(state, payload) {
            state.currentItemsArray = payload
        },
        setVitrine1(state, payload) {
            state.vitrine1 = payload
        },
        setVitrine2(state, payload) {
            state.vitrine2 = payload
        },
        setVitrine3(state, payload) {
            state.vitrine3 = payload
        },
        setVitrine4(state, payload) {
            state.vitrine4 = payload
        },
        setVitrine5(state, payload) {
            state.vitrine5 = payload
        },
        setVitrine6(state, payload) {
            state.vitrine6 = payload
        },
        setVitrine7(state, payload) {
            state.vitrine7 = payload
        },
        setVitrine8(state, payload) {
            state.vitrine8 = payload
        },
        setVitrine9(state, payload) {
            state.vitrine9 = payload
        },
        setVitrine10(state, payload) {
            state.vitrine10 = payload
        },
        setVitrine11(state, payload) {
            state.vitrine11 = payload
        },
        setVitrine12(state, payload) {
            state.vitrine12 = payload
        },
        setVitrine13(state, payload) {
            state.vitrine13 = payload
        },
        setVitrine14(state, payload) {
            state.vitrine14 = payload
        },
        setVitrine15(state, payload) {
            state.vitrine15 = payload
        },
        setVitrine16(state, payload) {
            state.vitrine16 = payload
        },
        setVitrine17(state, payload) {
            state.vitrine17 = payload
        },
        setVitrine18(state, payload) {
            state.vitrine18 = payload
        },
        setVitrine19(state, payload) {
            state.vitrine19 = payload
        },
        setVitrine20(state, payload) {
            state.vitrine20 = payload
        },
        setVitrine21(state, payload) {
            state.vitrine21 = payload
        },
        setVitrine22(state, payload) {
            state.vitrine22 = payload
        },
        setVitrine23(state, payload) {
            state.vitrine23 = payload
        },
        setVitrine24(state, payload) {
            state.vitrine24 = payload
        },
        setVitrine25(state, payload) {
            state.vitrine25 = payload
        },
        setVitrine26(state, payload) {
            state.vitrine26 = payload
        },
        setVitrine27(state, payload) {
            state.vitrine27 = payload
        },
        // setMarkers(state, payload) {
        //     state.markers = payload
        // },
        // setQuestions(state, payload) {
        //     state.questions = payload
        // },
        // setQuestionsSuffled(state, payload) {
        //     state.questionsShuffled = payload
        // },
        addPoint(state, payload) {
            // console.log("addpoint", payload)
            state.points.push(payload)
        },
        // addMarker(state, payload) {
        //     state.markers.push(payload)
        // },
        // addUser(state, payload) {
        //     // console.log("[addUser] payload", payload)
        //     state.users.push(payload)
        // },
        // addUserListArray(state, payload) {
        //     state.users = payload
        // }

        // setResults(state, payload) {
        //     state.allResults = payload
        // }
    },
    actions: {
        storeVitrineOrder({ commit }, payload) {
            commit('setLoading', true)
            const db = firebase.database()
            return db.ref('visitMuseumEinDor/vitrinesOrder/').set(payload.pointsOrder)
                .then(() => commit('setLoading', false))
                .catch(err => { commit('setLoading', false); throw err })
        },
        createNewItem({
            commit,
            getters
        }, payload) {
            commit('setLoading', true)
            console.log("[createNewItem] payload", payload)
            const db = firebase.database()
            // db.ref(payload.navigationName + '/' + getters.lang + '/points/' + payload.pointNumber).set(payload)
            return db.ref('visitMuseumEinDor/' + getters.lang + '/vitrine' + payload.vitrine + '/').push({point: payload})
            .then(_=> {
                commit('setLoading', false)
            })
            .catch(err => { commit('setLoading', false); throw err })
        },
        createNewVitrine({
            commit,
            getters
        }, payload) {
            console.log("[createNewVitrine]", payload)
            commit('setLoading', true)
            const db = firebase.database()
            return db.ref(payload.navigationName + '/' + getters.lang + '/vitrine/' + payload.pointNumber).update(payload)
                .then(() => commit('setLoading', false))
                .catch(err => { commit('setLoading', false); throw err })
        },

        updateItem({
            commit,
            getters
        }, payload) {
            console.log("updateItem - payload", payload)
            commit('setLoading', true)
            const db = firebase.database()
            return db.ref('visitMuseumEinDor/' + getters.lang + '/vitrine' + payload.vitrine + '/' + payload.itemKey + '/point/').update(payload)
                .then(() => commit('setLoading', false))
                .catch(err => { commit('setLoading', false); throw err })
        },
        updateVitrine({
            commit,
            getters
        }, payload) {
            // console.log("updateVitrine - payload", payload)
            commit('setLoading', true)
            const db = firebase.database()
            return db.ref(payload.navigationName + '/' + getters.lang + '/vitrine/' + payload.pointNumber).update(payload)
                .then(() => commit('setLoading', false))
                .catch(err => { commit('setLoading', false); throw err })
        },
        deleteItem({
            commit,
            getters
        }, payload) {
            // payload: { vitrine, itemKey }
            commit('setLoading', true)
            const db = firebase.database()
            return db.ref('visitMuseumEinDor/' + getters.lang + '/vitrine' + payload.vitrine + '/' + payload.itemKey).remove()
                .then(() => commit('setLoading', false))
                .catch(err => { commit('setLoading', false); throw err })
        },
        deleteVitrine({
            commit,
            getters
        }, payload) {
            // payload: { pointNumber, navigationName } -- removes the vitrine record and its items bucket
            commit('setLoading', true)
            const db = firebase.database()
            return Promise.all([
                db.ref(payload.navigationName + '/' + getters.lang + '/vitrine/' + payload.pointNumber).remove(),
                db.ref('visitMuseumEinDor/' + getters.lang + '/vitrine' + payload.pointNumber).remove()
            ]).then(() => commit('setLoading', false))
              .catch(err => { commit('setLoading', false); throw err })
        },
        fetchVitrineOrder({
            commit
        }) {
            return firebase.database().ref('visitMuseumEinDor/vitrinesOrder/').once('value').then(data => {
                commit('setVitrineOrder', data.val() || [])
            })
        },

        //   ******************************* FETCH PART ******************************************
        fetchPoints({
            commit,
            getters
        }, payload) {
            commit('setLoading', true)
            firebase.database().ref(payload.navigationName + '/' + payload.lang + '/points').once('value')
                .then(data => {
                    console.log(["payload.lang"], payload.lang)
                    // if (getters.lang == "fr") {
                    // this.points = data.val().he.points
                    this.points = data.val()
                    // } else {
                    //     this.points = data.val().en.points
                    // }
                    console.log("[fetchPoints] this.points", this.points)
                    commit('setPoints', this.points)
                })
            commit('setLoading', false)
        },
        checkVitrineHasItems({
            getters
        }, pointNumber) {
            // cheap existence check: limitToFirst(1) avoids downloading the whole vitrine's items
            return firebase.database().ref('visitMuseumEinDor/' + getters.lang + '/vitrine' + pointNumber)
                .limitToFirst(1).once('value')
                .then(data => data.exists())
        },
        fetchVitrineItems({
            commit,
            getters
        }, payload) {
            commit('setLoading', true)
            console.log("[vitrine number] payload", payload)
            console.log("[vitrine number] getters.lang", getters.lang)
            console.log("[vitrine number] getters.lang", Number(payload))

            return firebase.database().ref('visitMuseumEinDor/' + getters.lang + '/vitrine' + payload).once('value')
                .then(data => {

                    let vitrineItems = data.val()
                    console.log("[fetchVitrineItems] vitrineItems", vitrineItems)

                    commit('setVitrineItems', vitrineItems)


                    //USED TO ADD THE ITEM KEY IN THE ITEM ITSELF -- USED ONLY ONCE TO ADD TO EACH ITEM HIS KEY

                    ///!!!!!!!!!!!!!!! J'AI ENCORE BESOIN DE L-UTILISER POUR L-HEBREU, MAIS IL FAUX CHANGER LES NUMEROS DE VITRINE, OU COPIER TOUT L-ANGLAIS
                    // const arrayOfObj = Object.entries(vitrineItems).map((e) => ({ [e[0]]: e[1] }));
                    // console.log("[fetchVitrineItems] arrayOfObj", arrayOfObj)
                    // let arrayForKeyItems = []
                    // Object.values(arrayOfObj).forEach(item => {
                    //     console.log("item", item)
                    //     for (var key in item) {
                    //         console.log("key " + key);
                    //         firebase.database().ref('visitMuseumEinDor/' + getters.lang + '/vitrine' + payload + '/' + key + '/point').update({itemKey : key})
                    //       }
                    // })

                    commit('setLoading', false)
                })
        },

        fetchVitrinesOnlyForAdmin({
            commit,
            dispatch,
            getters
        }, payload) {
            // commit('setLoadingVitrinesOnly', true)
            commit('setLoading', true)
            console.log("getters.lang", getters.lang)

            //*************************ALL THIS TO TRY TO LOAD FASTER  */
            return firebase.database().ref(payload.navigationName + '/' + getters.lang + '/vitrine').once('value').then(data => {
                // console.log("[fetchDataGame ] getting infor for point 13 only", data.val())
                this.allVitrinesOnly = data.val()
                // console.log("this.allVitrinesOnly", this.allVitrinesOnly)
                commit('setVitrineOnlyArrayForAdmin', this.allVitrinesOnly)
                commit('setLoading', false)
            })
        },


        fetchVitrinesOnly({
            commit,
            dispatch,
            getters
        }, payload) {
            commit('setLoadingVitrinesOnly', true)
            commit('setLoading', true)
            console.log("getters.lang", getters.lang)

            const db = firebase.database()
            db.ref('visitMuseumEinDor/vitrinesOrder/').once('value').then(data => {
               // console.log("vitrnie order", data.val())
                commit('setVitrineOrder', data.val())
                let vitrineOrder = data.val()
                db.ref(payload.navigationName + '/' + getters.lang + '/vitrine').once('value').then(data => {
                    // console.log("[fetchDataGame ] getting infor for point 13 only", data.val())
                    this.allVitrinesOnly = data.val()
                   // console.log("this.allVitrinesOnly", this.allVitrinesOnly)
                    let vitrineOnlyArray = []
                    for (let i = 0; i < vitrineOrder.length; i++) {
                        Object.values(this.allVitrinesOnly).forEach(vitrine => {
                            if( vitrine.pointNumber == vitrineOrder[i]) {
                                vitrineOnlyArray.push(vitrine)
                            }
                        })
                    }
        
                 //   console.log("vitrineOnlyArray", vitrineOnlyArray)
                    localStorage.setItem("vitrineOnlyArray", vitrineOnlyArray);
                    commit('setVitrineOnlyArray', vitrineOnlyArray)
                    commit('setLoadingVitrinesOnly', false)
                    commit('setLoading', false)
                })

            })
        },
        fetchPointItems({
            commit,
            dispatch,
            getters
        }, payload) {
            commit('setLoading', true)

            //****WE DOWNLOAD THE ITEM LIST FROM FIREBASE AS PER THE POINTNUMBER*********************/
            firebase.database().ref(payload.navigationName + '/' + getters.lang + '/vitrine' + (Number(payload.pointNumber))).once('value').then(data => {
                this.currentItems = data.val()
                             console.log("[fetchPointsItems] this.currentItems + payload.pointNumber", this.currentItems, payload.pointNumber)

                localStorage.setItem("vitrine" + payload.pointNumber, "vitrine" + payload.pointNumber);
                commit('setVitrine' + (Number(payload.pointNumber)), this.currentItems)
                commit('setCurrentItems', this.currentItems)
                commit('setLoading', false)
                console.log("[fetchPointsItems] this.currentItems", this.currentItems)
            })
        },


        fetchGameData({
            commit,
            dispatch,
            getters
        }, payload) {
            // commit('setLoadingFirstPage', true)
            commit('setLoading', true)
            // console.log("setLoadingFirstPage", getters.loadingFirstPage)


            //*************************ALL THIS TO TRY TO LOAD FASTER  */
            firebase.database().ref(payload.navigationName + '/' + getters.lang + '/points/13').once('value').then(data => {
                // console.log("[fetchDataGame ] getting infor for point 13 only", data.val())
                commit('setFirstPoint', data.val())
                // commit('setLoadingFirstPage', false)
                // console.log("setLoadingFirstPage", getters.loadingFirstPage)
            })
                .then(() => {
                    firebase.database().ref(payload.navigationName).once('value')

                        .then(data => {

                            this.gameData = data.val()
                            // console.log("this.gameData = data.val()", this.gameData)
                            let allVitrines = []
                            let vitrine1 = []
                            let vitrine2 = []
                            let vitrine3 = []
                            let vitrine4 = []
                            let vitrine5 = []
                            let vitrine6 = []
                            let vitrine7 = []
                            let vitrineMain = []


                            // **************************FETCH POINTS
                            // if (getters.lang == "fr") {
                       //     console.log("B4 this.points")
                            this.points = data.val().he.points
                            // } else {
                            //     this.points = data.val().en.points
                            // }
                            commit('setPoints', this.points)

                            // let sortedPoints = this.points.sort((c1, c2) => (c1.vitrine < c2.vitrine) ? 1 : (c1.vitrine > c2.vitrine) ? -1 : 0);
                            // console.log("sortedPoints", sortedPoints);
                            this.points.forEach(point => {
                                let vitrineNumber = point.vitrine
                                switch (vitrineNumber) {
                                    case "1":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine1').push({
                                        //     point
                                        // })
                                        vitrine1.push(point)
                                        break;
                                    case "2":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine2').push({
                                        //     point
                                        // })
                                        vitrine2.push(point)
                                        break;
                                    case "3":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine3').push({
                                        //     point
                                        // })
                                        vitrine3.push(point)
                                        break;
                                    case "4":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine4').push({
                                        //     point
                                        // })
                                        vitrine4.push(point)
                                        break;
                                    case "5":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine5').push({
                                        //     point
                                        // })
                                        vitrine5.push(point)
                                        break;
                                    case "6":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine6').push({
                                        //     point
                                        // })
                                        vitrine6.push(point)
                                        break;
                                    case "7":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine7').push({
                                        //     point
                                        // })
                                        vitrine7.push(point)
                                        break;
                                    case "8":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine8').push({
                                        //     point
                                        // })
                                        break;
                                    case "9":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine9').push({
                                        //     point
                                        // })
                                        break;
                                    case "10":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine10').push({
                                        //     point
                                        // })
                                        break;
                                    case "11":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine11').push({
                                        //     point
                                        // })
                                        break;
                                    case "12":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine12').push({
                                        //     point
                                        // })
                                        break;
                                    case "13":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine13').push({
                                        //     point
                                        // })
                                        break;
                                    case "14":
                                        // firebase.database().ref(payload.navigationName + '/he/vitrine14').push({
                                        //     point
                                        // })
                                        break;
                                    case "main":
                                        vitrineMain.push(point)
                                        break;

                                }
                            })
                            allVitrines.push(vitrine7)
                            allVitrines.push(vitrine1)
                            allVitrines.push(vitrine2)
                            allVitrines.push(vitrine3)
                            allVitrines.push(vitrine4)
                            allVitrines.push(vitrine5)
                            allVitrines.push(vitrine6)
                            commit('setVitrines', allVitrines)
                            commit('setVitrinesMain', vitrineMain)

                            this.allVitrines = allVitrines
                            commit('setLoading', false)

                        })
                })
            console.log("setLoading", getters.loading)

        },

        /////////////////////////////////////LANGUAGES////////////////////////////////
        setHebrewLang({
            commit
        }) {
            commit('switchLang', "he")
        },
        setArabicLang({
            commit
        }) {
            commit('switchLang', "ar")
        },
        setEnglishLang({
            commit
        }) {
            commit('switchLang', "en")
        }
    },
    getters: {
        vitrineItems(state) {
            return state.vitrineItems
        },
        vitrineArrayOnly(state) {
            return state.vitrineArrayOnly
        },
        vitrineOnlyArrayForAdmin(state) {
            return state.vitrineOnlyArrayForAdmin
        },
        currentItemsArray(state) {
            return state.currentItemsArray
        },

        allVitrines(state) {
            return state.allVitrines
        },
        firstPoint(state) {
            return state.firstPoint
        },
        vitrinesMain(state) {
            return state.vitrinesMain
        },
        vitrine1(state) {
            return state.vitrine1
        },
        vitrine2(state) {
            return state.vitrine2
        },
        vitrine3(state) {
            return state.vitrine3
        },
        vitrine4(state) {
            return state.vitrine4
        },
        vitrine5(state) {
            return state.vitrine5
        },
        vitrine6(state) {
            return state.vitrine6
        },
        vitrine7(state) {
            return state.vitrine7
        },
        vitrine8(state) {
            return state.vitrine8
        },
        vitrine9(state) {
            return state.vitrine9
        },
        vitrine10(state) {
            return state.vitrine10
        },
        vitrine11(state) {
            return state.vitrine11
        },
        vitrine12(state) {
            return state.vitrine12
        },
        vitrine13(state) {
            return state.vitrine13
        },
        vitrine14(state) {
            return state.vitrine14
        },
        vitrine15(state) {
            return state.vitrine15
        },
        vitrine16(state) {
            return state.vitrine16
        },
        vitrine17(state) {
            return state.vitrine17
        },
        vitrine18(state) {
            return state.vitrine18
        },
        vitrine19(state) {
            return state.vitrine19
        },
        vitrine20(state) {
            return state.vitrine20
        },
        vitrine21(state) {
            return state.vitrine21
        },
        vitrine22(state) {
            return state.vitrine22
        },
        vitrine23(state) {
            return state.vitrine23
        },
        vitrine24(state) {
            return state.vitrine24
        },
        vitrine25(state) {
            return state.vitrine25
        },
        vitrine26(state) {
            return state.vitrine26
        },
        vitrine27(state) {
            return state.vitrine27
        },
        lang(state) {
            return state.lang
        },
        mapParameters(state) {
            return state.mapParameters
        },
        welcomePage(state) {
            return state.welcomePage
        },
        lettersArray(state) {
            return state.lettersArray
        },
        // gameParameters(state) {
        //     return state.gameParameters
        // },
        allNavGameNames(state) {
            return state.allNavGameNames
        },
        loading(state) {
            // console.log("[getters] loading => state.loading", state.loading)
            return state.loading
        },
        loadingVitrinesOnly(state) {
            // console.log("[getters] loading => state.loadingVitrinesOnly", state.loadingVitrinesOnly)
            return state.loadingVitrinesOnly
        },
        vitrineOrder(state) {
            return state.vitrineOrder
        },
        results(state) {
            return state.results
        },
        user(state) {
            return state.user
        },
        points(state) {
            return state.points
        },
        markers(state) {
            return state.markers
        },
        questions(state) {
            return state.questions
        },
        questionsShuffled(state) {
            return state.questionsShuffled
        },
        group(state) {
            return state.group
        },
        pointsArrayOrder(state) {
            return state.pointsArrayOrder
        },
        questionsList(state) {
            return state.questionsList
        },
        users(state) {
            return state.users
        },
        getUser(state) {
            return (userId) => {
                return state.users.find((user) => {
                    return user.id === userId
                })
            }
        }
    }
}